import axios from 'axios'
import api from '@/api'

const patientsOpinionsList = {
  state: {
    data: []
  },
  getters: {
    getPatientsOpinionList: state => state.data
  },
  mutations: {
    PATIENT_OPINION_LIST_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsOpinionListGet (context) {
      axios({
        method: 'POST',
        url: `${api}patients/opinions/list`,
      }).then(response => {
        context.commit('PATIENT_OPINION_LIST_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsOpinionsList
